// import React, { useEffect, useState } from "react";
// import {
//   disabledOnStatusValues,
//   masterCalculatedFieldsFn,
//   masterFormConfig,
//   masterSubmitApi,
//   parentIdColumnName,
//   statuses,
//   statusField,
//   transactionFormConfig,
// } from "./module";
// import Form from "../../../site/forms/master-transaction/form";

// const token = localStorage.getItem("zTaskAuthToken");

// function InvoiceForm({ rowId }) {
//   const [data, setData] = useState({
//     id: null,
//   });
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         if (rowId === undefined || Number.isNaN(parseInt(rowId))) return;
//         const response = await fetch(`${masterSubmitApi}/${rowId}`, {
//           method: "GET",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${token}`,
//           },
//         });

//         if (response.ok) {
//           const result = await response.json();
//           setData(result);
//         } else {
//           console.error("API Error:", response.statusText);
//         }
//       } catch (error) {
//         console.error("Network or unexpected error:", error);
//       }
//     };

//     fetchData();
//   }, [rowId]);
//   return (
//     <Form
//       masterFormConfig={masterFormConfig}
//       transactionFormConfig={transactionFormConfig}
//       initialData={rowId ? { id: rowId, ...data } : data}
//       onFormSuccess={(invId) =>
//         console.log("Form saved successfully, Inv ID:", invId)
//       }
//       moduleName="Invoice"
//       submitTogether={true}
//       parentIdColumnName={parentIdColumnName}
//       masterCalculatedFieldsFn={masterCalculatedFieldsFn}
//       statusField={statusField}
//       disabledOnStatusValues={disabledOnStatusValues}
//       statuses={statuses}
//     />
//   );
// }

// export default InvoiceForm;


import React, { useEffect, useState } from "react";
import {
  disabledOnStatusValues,
  masterCalculatedFieldsFn,
  masterFormConfig,
  masterSubmitApi,
  parentIdColumnName,
  statuses,
  statusField,
  transactionFormConfig,
} from "./module";
import Form from "../../../site/forms/master-transaction/form";

function InvoiceForm({ rowId }) {
  const [data, setData] = useState({
    id: null,
  });
  
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // ✅ FIX 1: Always get fresh token
        const token = localStorage.getItem("zTaskAuthToken");
        
        if (!token) {
          console.error("❌ No authentication token found");
          alert("Session expired. Please login again.");
          window.location.href = '/login';
          return;
        }

        // ✅ FIX 2: Handle "new" case explicitly
        if (rowId === undefined || rowId === null || rowId === "new" || Number.isNaN(parseInt(rowId))) {
          console.log("✅ Creating new invoice");
          setData({ id: null });
          setIsLoading(false);
          return;
        }

        // ✅ FIX 3: Fetch existing invoice data
        console.log(`📡 Fetching invoice data for ID: ${rowId}`);
        
        const response = await fetch(`${masterSubmitApi}/${rowId}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "Accept": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        if (response.ok) {
          const result = await response.json();
          console.log("✅ Invoice data fetched successfully:", result);
          setData(result);
        } else {
          if (response.status === 401) {
            console.error("❌ Authentication failed - token invalid");
            alert("Session expired. Please login again.");
            window.location.href = '/login';
            return;
          }
          
          console.error("❌ API Error:", response.status, response.statusText);
          alert(`Failed to load invoice: ${response.statusText}`);
          setData({ id: null });
        }
      } catch (error) {
        console.error("❌ Network error:", error);
        alert("Network error. Please check your connection and try again.");
        setData({ id: null });
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [rowId]); // ✅ FIX 4: Re-run when rowId changes

  // ✅ FIX 5: Show loading state
  if (isLoading) {
    return (
      <div style={{ padding: '40px', textAlign: 'center' }}>
        <div style={{ fontSize: '18px', color: '#666' }}>
          Loading invoice...
        </div>
      </div>
    );
  }

  return (
    <Form
      key={rowId || 'new'} // ✅ FIX 6: Force re-mount when ID changes
      masterFormConfig={masterFormConfig}
      transactionFormConfig={transactionFormConfig}
      initialData={data}
      onFormSuccess={(invId) =>
        console.log("Form saved successfully, Inv ID:", invId)
      }
      moduleName="Invoice"
      submitTogether={true}
      parentIdColumnName={parentIdColumnName}
      masterCalculatedFieldsFn={masterCalculatedFieldsFn}
      statusField={statusField}
      disabledOnStatusValues={disabledOnStatusValues}
      statuses={statuses}
    />
  );
}

export default InvoiceForm;
